import React from 'react';
import { LockIcon, AlertTriangleIcon, InfoIcon } from 'lucide-react';
type BannerType = 'locked' | 'warning' | 'info';
interface PermissionBannerProps {
  type: BannerType;
  message?: string;
}
const PermissionBanner: React.FC<PermissionBannerProps> = ({
  type,
  message
}) => {
  const getDefaultMessage = () => {
    switch (type) {
      case 'locked':
        return "This ticket group is locked. You cannot make changes until it's unlocked.";
      case 'warning':
        return "You don't have permission to perform this action.";
      case 'info':
        return 'Please complete required information before proceeding.';
      default:
        return '';
    }
  };
  const getBannerStyles = () => {
    switch (type) {
      case 'locked':
        return {
          bg: 'bg-gray-100',
          border: 'border-gray-300',
          icon: <LockIcon className="h-5 w-5 text-gray-500" data-id="element-52" />,
          textColor: 'text-gray-700'
        };
      case 'warning':
        return {
          bg: 'bg-amber-50',
          border: 'border-amber-200',
          icon: <AlertTriangleIcon className="h-5 w-5 text-amber-500" data-id="element-53" />,
          textColor: 'text-amber-800'
        };
      case 'info':
        return {
          bg: 'bg-blue-50',
          border: 'border-blue-200',
          icon: <InfoIcon className="h-5 w-5 text-blue-500" data-id="element-54" />,
          textColor: 'text-blue-800'
        };
      default:
        return {
          bg: 'bg-gray-100',
          border: 'border-gray-300',
          icon: <InfoIcon className="h-5 w-5 text-gray-500" data-id="element-55" />,
          textColor: 'text-gray-700'
        };
    }
  };
  const {
    bg,
    border,
    icon,
    textColor
  } = getBannerStyles();
  const displayMessage = message || getDefaultMessage();
  return <div className={`${bg} ${border} border rounded-md p-4`} data-id="element-56">
      <div className="flex" data-id="element-57">
        <div className="flex-shrink-0" data-id="element-58">{icon}</div>
        <div className="ml-3" data-id="element-59">
          <p className={`text-sm ${textColor}`} data-id="element-60">{displayMessage}</p>
        </div>
      </div>
    </div>;
};
export default PermissionBanner;